import { storeCookie } from '@news-mono/web-common'

export const CREATE_ACCOUNT_COOKIE_NAME = 'createAccountModals'
export const VERIFY_EMAIL_COOKIE_NAME = 'verifyEmailModal'

export interface CreateAccountBreachModalCookie {
    isStickyBannerIgnored: boolean
    expiresAt: Date
}

const EXCLUDED_PAGE_TYPES = ['homepage', 'static']

export const emailSentWithSuccessNotification =
    'A verification email has been sent.'
export const emailSentWithErrorNotification =
    'There was an error encountered verifying email.'

export const storeCreateAccountModalCookie = (
    isStickyBannerIgnored: boolean,
    expires: Date,
) => {
    const cookieValue: CreateAccountBreachModalCookie = {
        isStickyBannerIgnored: isStickyBannerIgnored,
        expiresAt: expires,
    }

    storeCookie(CREATE_ACCOUNT_COOKIE_NAME, cookieValue, {
        expires: expires,
    })
}

export const isPageTypeExcluded = (pageType: string) => {
    return EXCLUDED_PAGE_TYPES.includes(pageType)
}

export const getCookieExpiresInDay = (expiresInDay: number) => {
    return new Date(Date.now() + 1000 * 60 * 60 * 24 * expiresInDay)
}
